<template>
	<div class="class">
		<studentNav :current="current" @info-event="myInfoEvent" @public-event="publicEvent"></studentNav>
		<div class="class_cont bg_blue">
			<div class="class_div radius8 bs bg_white" v-if="JSON.stringify(data) != '{}'">
				<div class="paper_edit_title flex">
					<div class="paper_edit_title_l">
						<p class="f20px">{{data.data.name}}</p>
						<div class="f16px cl_gray mat10">答题用时：{{myHours}}:{{myMinutes}}:{{mySeconds}}</div>
					</div>
					<div class="paper_edit_title_r tc cl_white cur" @click="subject">交卷</div>
				</div>
				<div class="paper_edit mat30">
					<div class="paper_edit_l">
						<div class="paper_edit_nav f18px cl_dark">
							<div class="paper_edit_nav_list" :class="{'on': nav_cur == 1}">试卷</div>
							<!-- <div class="paper_edit_nav_list" :class="{'on': nav_cur == 2}" @click="navCheck(2)">答案与解析</div> -->
						</div>
						<div class="paper_edit_cont mat20 bs" :style="{maxHeight:height}">
							 <pdf v-for="i in numPages" :key="i" :src="src" :page="i" @page-loaded="pageLoaded($event)"></pdf>
						</div>
					</div>
					<div class="paper_edit_r" ref="paper_height">
						<div class="tc f20px">答题卡</div>
						<div class="cl_gray tc">共计{{data.data.num}}小题，总计{{data.data.fraction_all}}分</div>
						<div class="paper_edit_card mat20">
							<div class="paper_card_list" v-for="(item,index) in data.data.card_json_arr" :key="index">
								<div class="found_list_title flex f16px cl_violet radius8">
									<div class="found_list_title_l">{{item.number}}、{{item.type}}</div>
									<div>共{{item.topic.length}}题，{{item.fraction_all}}分</div>
								</div>
								<div class="found_list_cont mat20">
									<div class="found_list_item flex radius8" v-for="(second,secondIndex) in item.topic" :key="secondIndex">
										<div class="found_list_item_l flex">
											<div class="found_list_item_index">{{second.id}}</div>
											<div class="found_list_item_cont flex" v-if="item.type == '选择题'">
												<div class="found_list_item_check_cont flex cl_gray tc">
													<div class="radius found_list_item_check cur" v-for="(third,thirdIndex) in second.arr" :key="thirdIndex"
													:class="{'on': third.on}"  @click="check(index,secondIndex,thirdIndex)">{{third.name}}</div>
												</div>
											</div>
											<div class="found_list_item_cont flex" v-if="item.type == '判断题'">
												<div class="found_list_item_judge cl_gray tc cur" v-for="(third,thirdIndex) in second.arr" :key="thirdIndex"
												:class="{'on': third.on}" @click="judge(index,secondIndex,thirdIndex)">{{third.name}}</div>
											</div>
											<div class="found_list_item_cont" v-if="['选择题','判断题'].indexOf(item.type) < 0">
												<p class="f12px cl_gray">本小题作为主观题，不提供在线作答功能，由学生<br>在线下用纸笔作答，并自行校对答案并计算得分。</p>
											</div>
										</div>
										<div class="found_list_item_r"></div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import studentNav from '../../components/student_nav.vue'
	import pdf from 'vue-pdf'
	
	export default {
		name: 'task_school_paper',
		components: {
			studentNav,
			pdf,
		},
		props: {
			
		},
		data () {
			return {
				myInfo: {},
				public: {},
				current: {
					navCur: 1,
					listCur: 0,
					open: 0,
				},
				id: "",
				data: {},
				nav_cur: 1,
				loading: true,
				src: '',
				numPages: undefined, // 总页数
				curPageNum: 0, //当前页
				height: "600px",
				currentTime:0, //计时器
				timeObj: null,
				myHours: '00',
				myMinutes: '00',
				mySeconds: '00',
				start_time: "",
				end_time: "",
			}
		},
		created() {
			if (this.$route.query.id) {
				this.id = this.$route.query.id;
				this.getList();
			}
		},
		mounted() {
			this.testTimer();
			this.start_time = this.getTime();
		},
		destroyed () {
			clearInterval(this.timer);
		},
		methods: {
			myInfoEvent (data) {
				this.myInfo = data;
			},
			publicEvent (data) {
				this.public = data;
			},
			//计时
			testTimer(){
				this.timeFunction();
				this.timer = setInterval(() => {
					this.timeFunction();
				}, 1000)
			},
			timeFunction(){
				// 开始执行倒计时
				this.timeObj = { // 时间对象
					seconds: Math.floor(this.currentTime % 60),
					minutes: Math.floor(this.currentTime / 60) % 60,
					hours: Math.floor(this.currentTime / 60 / 60) % 24
				}
				// 计算出时分秒
				this.myHours = this.timeObj.hours<10?'0'+this.timeObj.hours:this.timeObj.hours;
				this.myMinutes = this.timeObj.minutes<10?'0'+this.timeObj.minutes:this.timeObj.minutes;
				this.mySeconds = this.timeObj.seconds<10?'0'+this.timeObj.seconds:this.timeObj.seconds;
				this.currentTime++;
			},
			getTime () {
				let t = "";
				let myDate = new Date();
				let year = myDate.getFullYear();
				let month = myDate.getMonth() + 1;
				let date = myDate.getDate();
				let hours = myDate.getHours();
				let minutes = myDate.getMinutes();
				let seconds = myDate.getSeconds();
				if (month < 10) {
					month = "0" + month;
				}
				if (date < 10) {
					date = "0" + date;
				}
				if (hours < 10) {
					hours = "0" + hours;
				}
				if (minutes < 10) {
					minutes = "0" + minutes;
				}
				if (seconds < 10) {
					seconds = "0" + seconds;
				}
				t = year + "-" + month + "-" + date + " " + hours + ":" + minutes + ":" + seconds
				return t;
			},
			getList () {
				this.$get("/api/student/get_my_homework_unfinished_dtl",{
					token: localStorage.getItem("token"),
					id: this.id,
				})
				.then(res => {
					let fraction_all = 0;
					let num = 0;
					for (let i = 0; i < res.data.data.card_json_arr.length; i++) {
						fraction_all += res.data.data.card_json_arr[i].fraction_all;
						res.data.data.fraction_all = fraction_all;
						num += res.data.data.card_json_arr[i].topic.length;
						res.data.data.num = num;
						for (let j = 0; j < res.data.data.card_json_arr[i].topic.length; j++) {
							if (res.data.data.card_json_arr[i].topic[j].arr) {
								for (let k = 0; k < res.data.data.card_json_arr[i].topic[j].arr.length; k++) {
									res.data.data.card_json_arr[i].topic[j].arr[k].on = false;
								}
							}
							res.data.data.card_json_arr[i].topic[j].mark = 0;
							res.data.data.card_json_arr[i].topic[j].is_right = 0;
							res.data.data.card_json_arr[i].topic[j].reply = "";
						}
					}
					this.data = res.data;
					let that = this;
					that.src = pdf.createLoadingTask(this.data.data.ques_file); // url是pdf文件的全路径
					that.src.promise.then(pdf => {
							that.numPages = pdf.numPages;
					});
					setTimeout(() => {
						let height= this.$refs.paper_height.offsetHeight;
						if (height > 600) {
							this.height = height - 60 + "px"
						}
					}, 0);
				});
			},
			navCheck (e) {
				this.nav_cur = e;
				this.curPageNum = 0;
			},
			pageLoaded(e) {
				this.curPageNum = e;
				if (this.curPageNum == this.numPages) { //加载完最后一页
					this.loading = false;
				}
			},
			check (index,secondIndex,thirdIndex) {
				this.data.data.card_json_arr[index].topic[secondIndex].arr[thirdIndex].on = !this.data.data.card_json_arr[index].topic[secondIndex].arr[thirdIndex].on;
			},
			judge (index,secondIndex,thirdIndex) {
				for (let i = 0; i < this.data.data.card_json_arr[index].topic[secondIndex].arr.length; i++) {
					this.data.data.card_json_arr[index].topic[secondIndex].arr[i].on = false;
				}
				this.data.data.card_json_arr[index].topic[secondIndex].arr[thirdIndex].on = true;
			},
			subject () {
				let data = this.data;
				data.use_time = this.myHours + ":" + this.myMinutes + ":" + this.mySeconds;
				data.start_time = this.start_time;
				data.end_time = this.getTime();
				data = JSON.stringify(data);
				this.$router.push({path: '/task_proof', query: {data: data}});
			},
		},
	}
</script>

<style>
</style>
